import classNames from 'clsx';
import React from 'react';

import styles from './Chest.scss';

export interface Props {
  tierId: number;
  currentPoints: number;
  targetPoints: number;
  expanded: boolean;
  cvlConfig: { cvl2: boolean };
}

const getClassName = ({ tierId, currentPoints, targetPoints, expanded, cvlConfig }: Props) =>
  classNames(
    cvlConfig.cvl2 ? styles.chest2 : styles.chest,
    styles[`tier${tierId}` as keyof typeof styles],
    { [styles.tierComplete]: targetPoints === currentPoints },
    { [styles.expanded]: expanded }
  );

const Chest: React.FC<Props> = (props) => <div className={getClassName(props)} />;

export default Chest;
